export enum DueDiligenceStatus {
  APPROVED = 'APPROVED',
  AWAITING_ASSESSMENT = 'AWAITING_ASSESSMENT',
  DECLINED = 'DECLINED',
}
